module.exports = __webpack_public_path__ + "static/blast-galaxy-order-guy-52472ca81c1a704c0d48dcf14421e3e3.png";